module.exports = __webpack_public_path__ + "media/img/bg-article-df65de48cbe4c7708bd4503a3ff992c1.png";